import {
  uploadAcceptanceMaterialPriceUrl,
  uploadSettleMaterialPriceUrl,
} from "@/api/commonApi.js";
export const contractManage = {
  title: "查看合同",
  breadcrumb: "合同管理",
  contractList: [
    {
      name: "合同名称",
      key: "contractName",
    },
    {
      name: "项目名称",
      key: "projectName",
    },
    {
      name: "甲方",
      key: "firstParty",
    },
    {
      name: "乙方",
      key: "secondParty",
    },
    {
      name: "采购单位",
      key: "purchaserEnterpriseName",
    },
    {
      name: "供应单位",
      key: "supplierEnterpriseName",
    },
    {
      name: "合同金额",
      key: "amount",
    },
    {
      name: "材料品类",
      key: "categoryNameList",
    },
    {
      name: "合同时间",
      key: "startDate",
      type: "dateRange",
    },
    {
      name: "定价方式",
      key: "pricingMethod",
      type: "radio",
    },
    {
      name: "备注",
      key: "remarks",
      width: "1130px",
    },
    {
      name: "合同附件",
      key: "lcContractAttachmentList",
      type: "attachment",
    },
  ],
  columns: [
    {
      columnsName: "采购材料清单",
      key: "materialPriceList",
      columns: [
        {
          name: "序号",
          key: "number",
        },
        {
          name: "材料名称",
          key: "materialName",
        },
        {
          name: "规格型号",
          key: "spec",
        },
        {
          name: "采购数量",
          key: "purchaseCount",
        },
        {
          name: "单位",
          key: "unit",
        },
        {
          name: "材料说明",
          key: "materialDesc",
        },
        {
          name: "含税单价",
          key: "taxPrice",
        },
        {
          name: "含税总价",
          key: "taxTotalPrice",
        },
        {
          name: "备注",
          key: "remarks",
        },
      ],
      exportBtn: true,
    },
  ],
};
export const orderManage = {
  title: "订单详情",
  breadcrumb: "订单管理",
  contractList: [
    {
      name: "合同名称",
      key: "contractName",
    },
    {
      name: "项目名称",
      key: "projectName",
    },
    {
      name: "采购单位",
      key: "purchaserEnterpriseName",
    },
    {
      name: "供应单位",
      key: "supplierEnterpriseName",
    },
    {
      name: "收货人",
      key: "consignee",
    },
    {
      name: "联系电话",
      key: "phoneNumber",
    },
    {
      name: "收货地址",
      key: "address",
    },
    {
      name: "进场日期",
      key: "entryDate",
    },
    {
      name: "备注",
      key: "remarks",
      width: "1130px",
      editable: true,
    },
  ],
  columns: [
    {
      columnsName: "采购材料清单",
      key: "materialPriceList",
      columns: [
        {
          name: "序号",
          key: "number",
        },
        {
          name: "材料名称",
          key: "materialName",
        },
        {
          name: "规格型号",
          key: "spec",
        },
        {
          name: "订单数量",
          key: "orderCount",
        },
        {
          name: "单位",
          key: "unit",
        },
        {
          name: "材料说明",
          key: "materialDesc",
        },
        {
          name: "含税单价",
          key: "taxPrice",
        },
        {
          name: "含税总价",
          key: "taxTotalPrice",
        },
        {
          name: "备注",
          key: "remarks",
        },
      ],
      exportBtn: true,
    },
  ],
};
export const acceptanceManage = {
  title: "验收单详情",
  breadcrumb: "验收管理",
  contractList: [
    {
      name: "合同名称",
      key: "contractName",
    },
    {
      name: "项目名称",
      key: "projectName",
    },
    {
      name: "采购单位",
      key: "purchaserEnterpriseName",
    },
    {
      name: "供应单位",
      key: "supplierEnterpriseName",
    },
    {
      name: "收货人",
      key: "consignee",
    },
    {
      name: "联系电话",
      key: "phoneNumber",
    },
    {
      name: "收货地址",
      key: "address",
    },
    {
      name: "进场日期",
      key: "entryDate",
    },
    {
      name: "备注",
      key: "remarks",
      width: "1130px",
    },
    {
      name: "发货时间",
      key: "deliveryTime",
    },
    {
      name: "发货方式",
      key: "deliveryWay",
    },
    {
      name: "司机姓名",
      key: "driverName",
    },
    {
      name: "司机联系方式",
      key: "driverPhone",
      width: "124px",
    },
  ],
  columns: [
    {
      columnsName: "采购材料清单",
      key: "materialPriceList",
      columns: [
        {
          name: "序号",
          key: "number",
          width: "120",
        },
        {
          name: "材料名称",
          key: "materialName",
        },
        {
          name: "规格型号",
          key: "spec",
        },
        {
          name: "订单数量",
          key: "orderCount",
        },
        {
          name: "单位",
          key: "unit",
        },
        {
          name: "材料说明",
          key: "materialDesc",
        },
        {
          name: "含税单价",
          key: "taxPrice",
        },
        {
          name: "含税总价",
          key: "taxTotalPrice",
        },
        {
          name: "备注",
          key: "remarks",
        },
        {
          name: "验收数量",
          key: "acceptCount",
          type: "number",
        },
        {
          name: "结算含税单价",
          key: "acceptTaxPrice",
          type: "number",
        },
        {
          name: "实际金额",
          key: "realityPrice",
          type: "number",
        },
        {
          name: "操作",
          key: "operate",
        },
      ],
      formRules: {
        acceptCount: [
          {
            required: true,
            message: "请输入验收数量",
            trigger: "change",
            type: "number",
          },
          {
            min: 1,
            type: "number",
            message: "数量应该大于0",
            trigger: "blur",
          },
        ],
        acceptTaxPrice: [
          {
            required: true,
            message: "请输入结算含税单价",
            trigger: "change",
            type: "number",
          },
          {
            min: 1,
            type: "number",
            message: "单价应该大于0",
            trigger: "blur",
          },
        ],
        realityPrice: [
          {
            required: true,
            message: "请输入实际金额",
            trigger: "change",
            type: "number",
          },
          {
            min: 1,
            type: "number",
            message: "金额应该大于0",
            trigger: "blur",
          },
        ],
      },
      uploadObject: {
        action: uploadAcceptanceMaterialPriceUrl,
        key: "lcAcceptId",
      },
      exportBtn: true,
      uploadBtn: true,
    },
  ],
};
export const settleManage = {
  title: "结算单详情",
  breadcrumb: "结算单详情",
  contractList: [
    {
      name: "合同名称",
      key: "contractName",
    },
    {
      name: "项目名称",
      key: "projectName",
    },
    {
      name: "采购单位",
      key: "purchaserEnterpriseName",
    },
    {
      name: "供应单位",
      key: "supplierEnterpriseName",
    },
    {
      name: "发票",
      key: "invoiceFileList",
      type: "attachment",
      fileType: "SETTLEMENT_INVOICE",
      editable: true,
    },
    {
      name: "计划付款时间",
      key: "paymentDate",
      width: "124px",
      type: "date",
      editable: true,
    },
    {
      name: "付款方式",
      key: "paymentMethod",
      type: "radio",
      editable: true,
    },
    {
      name: "付款金额",
      key: "paymentAmount",
      type: "number",
      editable: true,
    },
    {
      name: "付款凭证",
      key: "paymentVoucherFile",
      type: "attachment",
      fileType: "PAYMENT_VOUCHER_DOC",
      editable: true,
    },
    {
      name: "备注",
      key: "remarks",
      width: "1130px",
    },
  ],
  formRules: {
    paymentMethod: [
      {
        required: true,
        message: "请选择付款方式",
        trigger: "change",
        type: "number",
      },
    ],
    paymentAmount: [
      {
        required: true,
        message: "请填写付款金额",
        trigger: "blur",
        type: "number",
      },
      {
        min: 1,
        type: "number",
        message: "金额应该大于0",
        trigger: "blur",
      },
    ],
  },
  columns: [
    {
      columnsName: "验收单",
      key: "acceptList",
      // 订单列
      columns: [
        {
          name: "验收编号",
          key: "acceptNo",
        },
        {
          name: "订单编号",
          key: "orderNo",
        },
        {
          name: "合同名称",
          key: "contractName",
        },
        {
          name: "项目名称",
          key: "projectName",
        },
        {
          name: "采购单位",
          key: "purchaserEnterpriseName",
        },
        {
          name: "供应单位",
          key: "supplierEnterpriseName",
        },
        {
          name: "状态",
          key: "acceptStatus",
        },
        {
          name: "发货时间",
          key: "deliveryTime",
        },
        {
          name: "验收时间",
          key: "acceptanceTime",
        },
      ],
    },
    {
      columnsName: "采购材料清单",
      key: "materialPriceList",
      columns: [
        {
          name: "序号",
          key: "number",
          width: "120",
        },
        {
          name: "材料名称",
          key: "materialName",
        },
        {
          name: "规格型号",
          key: "spec",
        },
        {
          name: "结算数量",
          key: "settlementCount",type: 'number'
        },
        {
          name: "单位",
          key: "unit",
        },
        {
          name: "材料说明",
          key: "materialDesc",
        },
        {
          name: "含税单价",
          key: "taxPrice",
          type: 'number'
        },
        {
          name: "金额总计",
          key: "taxTotalPrice",
        },
        {
          name: "备注",
          key: "remarks",
        },
        {
          name: "操作",
          key: "operate",
        },
      ],
      formRules: {
        materialName: [
          {
            required: true,
            message: "请输入材料名称",
            trigger: "change",
          },
        ],
        spec: [
          {
            required: true,
            message: "请输入规格型号",
            trigger: "change",
          },
        ],
        settlementCount: [
          {
            required: true,
            message: "请输入结算数量",
            trigger: "blur",
            type: "number",
          },
          {
            min: 1,
            type: "number",
            message: "数量应该大于0",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入单位",
            trigger: "blur",
          },
        ],
        materialDesc: [
          {
            required: true,
            message: "请输入材料说明",
            trigger: "blur",
          },
        ],
        taxPrice: [
          {
            required: true,
            message: "请输入含税单价",
            trigger: "blur",
            type: "number",
          },
          {
            min: 1,
            type: "number",
            message: "价格应该大于0",
            trigger: "blur",
          },
        ],
      },
      uploadObject: {
        action: uploadSettleMaterialPriceUrl,
        key: "lcSettlementId",
      },
      exportBtn: true,
      uploadBtn: true,
    },
  ],
};
// 验收状态
export const acceptStatusDic = {
  1: "完成验收",
  2: "验收不通过",
  3: "作废",
};
// 支付方式
export const paymentMethodDic = {
  1: "线下支付",
  2: "金融支付",
};
// 定加方式
export const pricingMethodDic = {
  1: "固定价",
  2: "浮动价",
};
// 供方-操作步骤
export const supplierRecords = [
  {
    name: "接收订单",
    modalContent: [
      {
        label: "生产周期",
        key: "dateCycle",
        type: "dateRange",
      },
      {
        label: "供应商备注",
        key: "remarks",
        type: "input",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      dateCycle: [
        {
          required: true,
          message: "请选择生产周期",
          trigger: "blur",
          type: "array",
        },
      ],
      remarks: [
        {
          required: true,
          message: "请填写采购商备注",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      dateCycle: [],
      remarks: "",
      operationTime: "",
    },
  },
  {
    name: "订单发货",
    modalContent: [
      {
        label: "发货时间",
        key: "time",
        type: "date",
      },
      {
        label: "发货方式",
        key: "methods",
        type: "input",
      },
      {
        label: "司机姓名",
        key: "name",
        type: "input",
      },
      {
        label: "司机联系方式",
        key: "phone",
        type: "input",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      time: [
        {
          required: true,
          message: "请选择发货时间",
          trigger: "blur",
        },
      ],
      methods: [
        {
          required: true,
          message: "请填写发货方式",
          trigger: "blur",
        },
      ],
      name: [
        {
          required: true,
          message: "请填写司机姓名",
          trigger: "blur",
        },
      ],
      phone: [
        {
          required: true,
          message: "请填写司机联系方式",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      time: "",
      methods: "",
      name: "",
      phone: "",
      operationTime: "",
    },
  },
  {
    name: "对账完成",
    modalContent: [
      {
        label: "采购单位对账人",
        key: "purchasePerson",
        type: "input",
      },
      {
        label: "供应单位对账人",
        key: "supplierPerson",
        type: "input",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      purchasePerson: [
        {
          required: true,
          message: "请填写采购单位对账人",
          trigger: "blur",
        },
      ],
      supplierPerson: [
        {
          required: true,
          message: "请填写供应单位对账人",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      purchasePerson: "",
      supplierPerson: "",
      operationTime: "",
    },
  },
  {
    name: "结算完成",
    modalContent: [
      {
        label: "采购单位结算确认人",
        key: "purchasePerson",
        type: "input",
      },
      {
        label: "供应单位结算确认人",
        key: "supplierPerson",
        type: "input",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      purchasePerson: [
        {
          required: true,
          message: "请填写采购单位结算确认人",
          trigger: "blur",
        },
      ],
      supplierPerson: [
        {
          required: true,
          message: "请填写供应单位结算确认人",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      purchasePerson: "",
      supplierPerson: "",
      operationTime: "",
    },
  },
];

// 采方-操作步骤
export const purchaseRecords = [
  {
    name: "提交订单",
    modalContent: [
      {
        label: "采购商备注",
        key: "remarks",
        type: "input",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      remarks: [
        {
          required: true,
          message: "请填写采购商备注",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      remarks: "",
      operationTime: "",
    },
  },
  {
    name: "结单",
    modalContent: [
      {
        label: "结算状态",
        key: "status",
        type: "radio",
      },
      {
        label: "结算说明",
        key: "remarks",
        type: "input",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      status: [
        {
          required: true,
          message: "请选择结算状态",
          trigger: "blur",
        },
      ],
      remarks: [
        {
          required: true,
          message: "请填写结算说明",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      status: "",
      remarks: "",
      operationTime: "",
    },
  },
  {
    name: "完成验收",
    modalContent: [
      {
        label: "验收人",
        key: "personName",
        type: "input",
      },
      {
        label: "发货方式",
        key: "methods",
        type: "input",
      },
      {
        label: "验收说明",
        key: "remarks",
        type: "input",
      },
      {
        label: "验收单",
        key: "files",
        type: "upload",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      personName: [
        {
          required: true,
          message: "请填写验收人",
          trigger: "blur",
        },
      ],
      methods: [
        {
          required: true,
          message: "请填写验收说明",
          trigger: "blur",
        },
      ],
      remarks: [
        {
          required: true,
          message: "请填写发货方式",
          trigger: "blur",
        },
      ],
      files: [
        {
          required: true,
          message: "请上传验收单",
          type: "array",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      personName: "",
      methods: "",
      remarks: "",
      files: [],
      operationTime: "",
    },
  },
  {
    name: "验收不通过",
    modalContent: [
      {
        label: "验收人",
        key: "personName",
        type: "input",
      },
      {
        label: "发货方式",
        key: "methods",
        type: "input",
      },
      {
        label: "不通过原因",
        key: "rason",
        type: "input",
      },
      {
        label: "验收单",
        key: "files",
        type: "upload",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      personName: [
        {
          required: true,
          message: "请填写验收人",
          trigger: "blur",
        },
      ],
      methods: [
        {
          required: true,
          message: "请填写发货方式",
          trigger: "blur",
        },
      ],
      rason: [
        {
          required: true,
          message: "请填写不通过原因",
          trigger: "blur",
        },
      ],
      files: [
        {
          required: true,
          message: "请上传验收单",
          type: "array",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      personName: "",
      methods: "",
      rason: "",
      files: [],
      operationTime: "",
    },
  },
  {
    name: "发起对账",
    modalContent: [
      {
        label: "发起对账人",
        key: "peoson",
        type: "input",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      peoson: [
        {
          required: true,
          message: "请填写发起对账人",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      peoson: "",
      operationTime: "",
    },
  },
  {
    name: "发起结算",
    modalContent: [
      {
        label: "发起结算人",
        key: "personName",
        type: "input",
      },
      {
        label: "完成时间",
        key: "operationTime",
        type: "date",
      },
    ],
    rules: {
      personName: [
        {
          required: true,
          message: "请填写发起结算人",
          trigger: "blur",
        },
      ],
      operationTime: [
        {
          required: true,
          message: "请选择完成时间",
          trigger: "change",
        },
      ],
    },
    commitData: {
      personName: "",
      operationTime: "",
    },
  },
];
